import React from 'react'
import classnames from 'classnames'

function getClassName(locals) {
    const len = locals.path.length
    return classnames({
        'fieldset': true,
        [`fieldset-depth-${len}`]: true,
        [`fieldset-${locals.path.join('-')}`]: len > 0,
        [locals.className]: locals.className
    })
}

export default function renderFieldset(children, locals) {
    const legend = locals.label
        ? <div className="col-xs-12"><p className="spark-mar-1">{locals.label}</p></div>
        : null

    const props = {
        className: getClassName(locals),
        disabled: locals.disabled
    }

    let errorElement = undefined
    if (locals.hasError && locals.error) {
        errorElement = React.createElement('div', {className: 'col-xs-12'},
            React.createElement("span", {className: 'spark-checkbox-group__message'}, locals.error.props.children)
        )
        props['data-error'] = true
    }

    return React.createElement.apply(null, [
        'div',
        props,
        legend
    ].concat(children.filter((child) => child.props.className !== 'ui message error'))
        .concat([errorElement]))
}



// WEBPACK FOOTER //
// ./src/shared/components/tcomb/renderFieldset.js